import { RootState } from '../../rootReducer';
import {
  IInvoiceDealValidationState,
  IInvoiceDealValidationStatePlgExternal3
} from './types';
import { BlockedByFeature } from '../../../featureToggles/features/utils';
import { ApiError } from '../../../services/api';

const getInvoiceDealValidationState = (state: Pick<RootState, 'accounts'>): IInvoiceDealValidationState | undefined => {
  const invoiceDealValidationState: IInvoiceDealValidationStatePlgExternal3 = state.accounts.invoiceDealValidation;
  if (invoiceDealValidationState === BlockedByFeature) {
    return;
  }
  return invoiceDealValidationState;
};

export const selectInvoiceDealValidationError = (state: Pick<RootState, 'accounts'>): ApiError | undefined => getInvoiceDealValidationState(state)?.error;
export const selectInvoiceDealValidationLoading = (state: Pick<RootState, 'accounts'>): boolean => getInvoiceDealValidationState(state)?.loading === true;
export const selectInvoiceDealValidationCanContinue = (state: Pick<RootState, 'accounts'>): boolean => getInvoiceDealValidationState(state)?.canContinue === true;

